export const QAExample = {
  login: {
    question: '列出一些年夜饭好意头的菜肴以及其寓意。',
    answer:
      '年夜饭是中国农历新年除夕夜的传统晚餐，是家人团聚、共同欢庆新年的重要活动。以下是一些年夜饭好意头的菜肴以及其寓意：\n\n1. 鱼：年夜饭必不可少的一道菜是鱼，因为“鱼”和“余”谐音，寓意着年年有余，表示家中生活富裕，财源广进。\n\n2. 鸡：鸡肉象征着“团圆”，因为鸡在汉语中与“家”谐音，所以年夜饭中必不可少。'
  },
  register: {
    question: '想自己做手冲咖啡，需要准备什么工具？',
    answer:
      '制作手冲咖啡需要以下工具：\n\n1. 咖啡磨豆机：用于将咖啡豆磨成适合手冲咖啡的细粉。\n\n2. 手冲壶：用于将热水加热并控制水流，以便将咖啡萃取出最佳的口感和香气。\n\n3. 滤纸：用于过滤咖啡渣，并使咖啡液体顺畅流下。\n\n4. 咖啡滤杯：用于将咖啡渣隔离出来，并控制水流，以便将咖啡萃取出最佳的口感和香气。\n\n5. 咖啡豆：用于制作手冲咖啡，需要选择新鲜且烘焙程度适当的咖啡豆。\n\n6. 热水壶：用于加热水，以确保热水的温度适合手冲咖啡。'
  },
  apply: {
    question: '10岁小朋友生日，可以怎么庆祝？',
    answer:
      '10 岁小朋友过生日，可以考虑下面几种方式来庆祝：\n\n1. 在家里举行生日派对，邀请同学和朋友来家里玩，并准备一些小吃和饮料。\n\n2. 去当地的游乐场或公园游玩，度过一个愉快的周末。\n\n3. 去当地的博物馆或科技馆参观，了解世界文化和科技知识。'
  }
}

// 秘钥
export const AesKey = 'jdkjf76787wef97ewfew9few78fwefwa'

// 手机号验证
export const PhoneRule = /^1\d{10}/

// 邮箱验证
export const EmailRule =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i

// export const SessionRound = 5 // 会话轮次
export const SessionRound = 100 // temp_test

export const SpecialMsgDic = {
  another_request_in_progress: {
    msg: '当前还有其他请求正在进行，',
    retryBtn: true
  },
  rate_limit: { msg: '访问接口速率超限制。' },
  count_limit: { msg: '非常抱歉，今日剩余内测次数0次。' },
  input_violation: {
    msg: '非常抱歉，我只是一个语言模型，暂时无法回答该问题，敬请谅解。'
  },
  output_violation: {
    msg: '非常抱歉，我只是一个语言模型，暂时无法回答该问题，敬请谅解。'
  },
  border_line: { msg: '检测到本次对话可能包含错误或有偏见的内容。' },
  invalid_lang: {
    msg: '抱歉，您输入的语言我暂时没有掌握，无法为您提供有效的解答。'
  },
  error: { msg: '本次回答网络超时，其他操作正常使用。', retryBtn: true },
  error_network_task_id: {
    msg: '本次回答网络超时，其他操作正常使用。',
    retryBtn: true
  },
  error_timeout: {
    msg: '本次回答网络超时，其他操作正常使用。',
    retryBtn: true
  },
  error_network_context_id: {
    msg: '本次回答网络超时，其他操作正常使用。',
    retryBtn: true
  },
  account_abnormal: { msg: '您的帐号由于存在异常行为，暂时被系统锁定。' },
  img_error: { msg: '当前请求人数过多，请稍候再试…' },
  error_length_too_long: { msg: '抱歉，本轮对话已结束', newBtn: true },
  sensitive_warning: {
    msg: '系统检测到您的账号异常输入较多，异常输入过多可能导致账号不可用，请谨慎使用。'
  },

  input_sensitive: {},
  output_sensitive: {},
  manual_intervene: {},
  glms_error: { msg: '回答错误，其他操作正常使用，请重试', retryBtn: false },
  system_error: { msg: '系统错误，其他操作正常使用，请重试', retryBtn: false },
  default: '清言正在忙碌中，可能回复不及时，您可以稍后再问我~'
}

// export const watermarkBlackList = ['645e0a40d455ebd8f1a3e75f']

// 版权文案
export const COPYRIGHT_TEXT = '以上内容均由AI生成,仅供参考和借鉴'

// 长文档智能体ID
export const LONG_DOC_ASSIST_ID = '658a7988b8a9a98d38725745'
